import React, { useEffect } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import BookLink from "./BookLink";
import Header from "./Header";
import Footer from "./Footer";
import { Calendar } from "lucide-react";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main" className="skip-link" data-testid="skip-link">Skip to content</a>
      <Header />
      <main id="main" className="flex-1" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />

      {/* Sticky mobile booking bar */}
      <BookLink
        
        className="sm:hidden fixed bottom-4 left-4 right-4 z-30 btn-petal justify-center shadow-petal soft-glow"
        data-testid="sticky-mobile-book"
      >
        <Calendar size={14} />
        Book Now
      </BookLink>
    </div>
  );
}
